import {
  Box,
  Button,
  Divider,
  Typography,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { React, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import SaveIcon from "@mui/icons-material/Save";
import PublishIcon from "@mui/icons-material/Publish";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {
  cloneCustomerGroup,
  resetAllStates,
  saveCustomerGroup,
  submitCustomerGroup,
  uploadFileForCustomerGroup,
  setCGState
} from "./customerGroupSetupSlice";
import dayjs from "dayjs";
import { useState } from "react";
import { useEffect } from "react";
import CollapseSection from "../../../components/ui/CollapseSection";


export default function Summary() {
    
  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;

  const isRestrictedAccess = setAccess;
  const dispatch = useDispatch();
  const cgState = useSelector((store) => store.customerGroupSetup);
  const {
    editCGName,
    editFromDate,
    editToDate,
    selCustomers,
    countryID,
    editComments,
    createEditStartEndDateModalOpened,
    customerTypeCode,
    customerLevelID,
    customerGroupDetail,
    files,
  } = cgState;

  const [hideCloneButton, setHideCloneButton] = useState(true);

  useEffect(() => {
    toggleVisibilityOfCloneButton();
  }, [customerGroupDetail]);

  function toggleVisibilityOfCloneButton() {
    if (
      customerGroupDetail &&
      customerGroupDetail.sentToSAP === "Y" &&
      customerGroupDetail.status === "Submitted"
    ) {
      setHideCloneButton(false);
    } else {
      setHideCloneButton(true);
    }
  }

  function getDateFromDayjsDate(date, exactTime) {
    console.log("CGCreate_getDateFromDayjsDate_InputDate", date);
    let outputDate = null;
    if (date && date instanceof dayjs) {
      const year = date.year();
      const month = date.month() + 1;
      const day = date.date();
      const time = new Date();

      if (exactTime) {
        const formattedTime = time.toLocaleTimeString("en-US", {
          hour12: false,
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        });
        outputDate = `${year}-${month < 10 ? "0" + month : month}-${
          day < 10 ? "0" + day : day
        }T${formattedTime}`;
      } else {
        outputDate = `${year}-${month < 10 ? "0" + month : month}-${
          day < 10 ? "0" + day : day
        }T00:00:00`;
      }
    } else if (date && typeof date === "string") {
      outputDate = date;
    }
    console.log("CGCreate_getDateFromDayjsDate_OutputDate", outputDate);
    return outputDate;
  }

  function formatCustomersDate() {
    const updatedCustomers = selCustomers.map((item) => {
      if (
         item.hasOwnProperty("effectiveStartDate") &&
         item.hasOwnProperty("effectiveEndDate")
      ) {
         return item;
      }
      return {
         ...item,
         effectiveStartDate: editFromDate,
         effectiveEndDate: editToDate,
      };
   });
   dispatch(setCGState("selCustomers", updatedCustomers));
    const customerList = updatedCustomers.map((item) => {
      return {
        ...item,
        effectiveStartDate: getDateFromDayjsDate(
          item.effectiveStartDate,
          false
        ),
        effectiveEndDate: getDateFromDayjsDate(item.effectiveEndDate, false),
      };
    });
    return customerList;
  }

  function getCustomerGroupFiles() {
    const groupFiles = files.map((item) => {
      return {
        customerGroupFileID: item.customerGroupFileID
          ? item.customerGroupFileID
          : 0,
        customerGroupID: item.customerGroupID ? item.customerGroupID : 0,
        filePath: item.name ? item.name : item.filePath,
        fileType: item.type ? item.type : item.fileType,
      };
    });
    return groupFiles;
  }

  function getFilePaths() {
    let filePaths = [];
    files.forEach((file, index) => {
      if (file instanceof File === false) {
        filePaths.push(file.filePath ? file.filePath : file.name);
      }
    });
    return filePaths;
  }

  function submitCG() {
    const data = JSON.parse(localStorage.getItem("data"));
    const createdCG = {
      customerlist: formatCustomersDate(),
      customerGroupFiles: getCustomerGroupFiles(),
      selectedCustomerID: [],
      FilePaths: getFilePaths(),
      countryID,
      customerGroupName: editCGName,
      comments: editComments,
      updatedBy: data.email,
      email: data.email,
      effectiveStartDate: getDateFromDayjsDate(editFromDate, false),
      effectiveEndDate: getDateFromDayjsDate(editToDate, false),
      updatedDate: dayjs().toISOString(),
      customerGroupTypeCode: customerTypeCode,
      customerGroupLevelCode: customerLevelID,
      customerGroupID: customerGroupDetail.customerGroupID,
      sentToSAP: "N",
      status: "Submitted",
      previousGroupID: 0,
      sapGrpCode: "",
      activeInScenarios: 0,
    };

    const fileData = new FormData();
    files.forEach((file, index) => {
      if (file instanceof File) {
        fileData.append("files", file);
      }
    });
    dispatch(uploadFileForCustomerGroup(fileData));

    console.log(createdCG);
    dispatch(submitCustomerGroup(createdCG));
    dispatch(resetAllStates({ edit: true }));
  }

  function saveCG() {
    const data = JSON.parse(localStorage.getItem("data"));
    const createdCG = {
      customerlist: formatCustomersDate(),
      customerGroupFiles: getCustomerGroupFiles(),
      selectedCustomerID: [],
      FilePaths: getFilePaths(),
      countryID,
      customerGroupName: editCGName,
      comments: editComments,
      updatedBy: data.email,
      email: data.email,
      effectiveStartDate: getDateFromDayjsDate(editFromDate, false),
      effectiveEndDate: getDateFromDayjsDate(editToDate, false),
      updatedDate: dayjs().toISOString(),
      customerGroupTypeCode: customerTypeCode,
      customerGroupLevelCode: customerLevelID,
      customerGroupID: customerGroupDetail.customerGroupID,
      sentToSAP: "N",
      status: "Draft",
      previousGroupID: 0,
      sapGrpCode: "",
      activeInScenarios: 0,
    };

    const fileData = new FormData();
    files.forEach((file, index) => {
      if (file instanceof File) {
        fileData.append("files", file);
      }
    });
    dispatch(uploadFileForCustomerGroup(fileData));

    console.log(createdCG);
    dispatch(saveCustomerGroup(createdCG));
    dispatch(resetAllStates({ edit: true }));
  }

  function cloneCG() {
    const data = JSON.parse(localStorage.getItem("data"));
    // countryID
    // countryCode
    // filePaths
    // files
    // tranOptions
    const createdCG = {
      customerlist: formatCustomersDate(),
      customerGroupFiles: getCustomerGroupFiles(),
      selectedCustomerID: [],
      FilePaths: getFilePaths(),
      countryID,
      customerGroupName: editCGName,
      comments: editComments,
      updatedBy: data.email,
      email: data.email,
      effectiveStartDate: getDateFromDayjsDate(editFromDate, false),
      effectiveEndDate: getDateFromDayjsDate(editToDate, false),
      updatedDate: dayjs().toISOString(),
      customerGroupTypeCode: customerTypeCode,
      customerGroupLevelCode: customerLevelID,
      customerGroupID: customerGroupDetail.customerGroupID,
      sentToSAP: "N",
      status: "Draft",
      previousGroupID: 0,
      sapGrpCode: "",
      activeInScenarios: 0,
    };

    const fileData = new FormData();
    files.forEach((file, index) => {
      if (file instanceof File) {
        fileData.append("files", file);
      }
    });
    dispatch(uploadFileForCustomerGroup(fileData));

    console.log(createdCG);
    dispatch(cloneCustomerGroup(createdCG));
  }

  return (
    <Box sx={{ mt: 1 }}>
      {/* <Typography
            sx={{ fontWeight: "bold", color: "blue.main" }}
            gutterBottom
         >
            Summary
         </Typography> */}
      {/* <Box sx={{ mt: 3, display: "flex", flexDirection: "row" }} >
				<Typography sx={{ fontWeight: "bold", color: "blue.main", width: "100%", }} 
				className="compHeading"
				>
					Summary
				</Typography>
			</Box> */}
      <CollapseSection title="Summary">
        <Typography sx={{ fontWeight: "bold" }}>
          Customer Group Name:
        </Typography>
        <Typography>{editCGName}</Typography>
        <Typography sx={{ fontWeight: "bold" }}>Customers:</Typography>
        <Box
          sx={{
            width: 700,
            height: 200,
            border: 1,
            borderRadius: 1,
            overflow: "auto",
            borderColor: "#c6c6c6",
            marginBottom: "10px",
          }}
        >
          <List>
            {selCustomers.map((item, index) => {
              return (
                <ListItem key={index}>
                  <ListItemText>{item.customerName}</ListItemText>
                </ListItem>
              );
            })}
          </List>
        </Box>
        <Typography sx={{ fontWeight: "bold" }}>Validity Period:</Typography>
        <Typography>
          From {new Date(editFromDate).toLocaleDateString("en-UK", {
               year:'numeric',
               month:'2-digit',
               day:'2-digit'
            })} To{" "}
          {new Date(editToDate).toLocaleDateString("en-UK", {
               year:'numeric',
               month:'2-digit',
               day:'2-digit'
            })}
        </Typography>
      </CollapseSection>
      <Divider sx={{ mt: 4 }} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          mt: 2,
        }}
      >
        <Button
          startIcon={<SaveIcon />}
          disabled={!isRestrictedAccess}
          sx={{
            bgcolor: "blue.main",
            color: "white.main",
            textTransform: "none",
            fontWeight: "bold",
            mt: 1,
            mr: 2,
            "&:hover": {
              bgcolor: "skyBlue.main",
              color: "black.main",
            },
          }}
          onClick={saveCG}
        >
          Save
        </Button>

        <Button
          startIcon={<PublishIcon />}
          disabled={!isRestrictedAccess}
          sx={{
            bgcolor: "blue.main",
            color: "white.main",
            textTransform: "none",
            fontWeight: "bold",
            mt: 1,
            mr: 2,
            "&:hover": {
              bgcolor: "skyBlue.main",
              color: "black.main",
            },
          }}
          onClick={submitCG}
        >
          Submit
        </Button>

        <Button
          startIcon={<ContentCopyIcon />}
          sx={{
            bgcolor: "blue.main",
            color: "white.main",
            textTransform: "none",
            fontWeight: "bold",
            display: hideCloneButton ? "none" : "block",
            mt: 1,
            "&:hover": {
              bgcolor: "skyBlue.main",
              color: "black.main",
            },
          }}
          onClick={cloneCG}
        >
          Clone
        </Button>
      </Box>
    </Box>
  );
}
